import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

const OrdersBreakdownChart = ({ data }) => {
  const chartData = [
    { name: 'Completed', value: data?.completed_orders || 0, color: '#28a745' },
    { name: 'Active',    value: data?.active_orders    || 0, color: '#007bff' },
    { name: 'Pending',   value: data?.pending_orders   || 0, color: '#ffc107' },
    { name: 'Cancelled', value: data?.cancelled_orders || 0, color: '#dc3545' },
  ];

  const total = chartData.reduce((sum, item) => sum + item.value, 0);

  const dataWithPercentages = chartData.map(item => ({
    ...item,
    percentage: total > 0 ? Math.round((item.value / total) * 100) : 0,
  }));

  return (
    <div className="chart-widget" style={{ background: 'white', padding: '16px', borderRadius: '8px', width: '100%', overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.08)' }}>
      <h3 style={{ fontSize: '14px', fontWeight: '700', marginBottom: '12px', color: '#1a1a1a' }}>Orders Breakdown</h3>
      <div style={{ display: 'flex', gap: '16px', alignItems: 'center', flexWrap: 'wrap' }}>
        {/* Pie chart with fixed pixel dimensions — no ResponsiveContainer height:auto issue */}
        <div style={{ position: 'relative', width: '130px', height: '130px', flexShrink: 0 }}>
          <ResponsiveContainer width={130} height={130}>
            <PieChart>
              <Pie data={dataWithPercentages} cx="50%" cy="50%" innerRadius={30} outerRadius={55} dataKey="value" strokeWidth={0}>
                {dataWithPercentages.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
          <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', textAlign: 'center', pointerEvents: 'none' }}>
            <div style={{ fontSize: '20px', fontWeight: '700', color: '#1f2937', lineHeight: 1 }}>{total}</div>
            <div style={{ fontSize: '10px', color: '#6b7280' }}>Total</div>
          </div>
        </div>
        {/* Stats list */}
        <div style={{ flex: 1, minWidth: '120px' }}>
          {dataWithPercentages.map((item, index) => (
            <div key={index} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '5px 0', borderBottom: '1px solid #f3f4f6' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <span style={{ background: item.color, width: '8px', height: '8px', borderRadius: '50%', display: 'inline-block' }}></span>
                <span style={{ fontSize: '12px', color: '#374151' }}>{item.name}</span>
              </div>
              <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                <span style={{ fontSize: '13px', fontWeight: '600', color: '#1f2937' }}>{item.value}</span>
                <span style={{ fontSize: '11px', color: '#6b7280' }}>{item.percentage}%</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OrdersBreakdownChart;
